import * as React from 'react'
import { AppBar, Toolbar, IconButton, Typography, makeStyles, createStyles, Theme, AppBarProps, MenuItem, Menu } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1
        }
    }),
);

interface HeaderProps extends AppBarProps {
    title?: string
    showMenu?: boolean
    onMenuClick?: () => void
}

const Header = ({ title, showMenu,onMenuClick, ...props }: HeaderProps) => {
    const classes = useStyles()
    const history = useHistory()
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);


    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (quit: number = 0) => () => {
        setAnchorEl(null);
        if(quit===1){
            localStorage.removeItem('user')
            history.replace('/signin')
        }
    };

    React.useEffect(()=>{
        if(title){
            document.title = title;
        }
    },[title])

    return <React.Fragment>
        <AppBar {...props}>
            <Toolbar >
                {showMenu && <IconButton onClick={onMenuClick} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                    <MenuIcon  />
                </IconButton>}
                <Typography variant="h6" color="inherit" className={classes.title}>
                    {title}
                </Typography>
                <div>
                    <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <AccountCircle />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={open}
                        onClose={handleClose()}
                    >
                        <MenuItem onClick={handleClose(1)}>退出登录</MenuItem>
                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    </React.Fragment>
}

export default Header